var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"small","type":_vm.isUsedDialog ? 'info' : 'primary',"plain":!_vm.isUsedDialog,"icon":"el-icon-bank-card","loading":_vm.loading},on:{"click":_vm.read}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }